import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2, MapPin } from 'lucide-react';
import { purchaseNotifications } from '../data/constants';
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialTimer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextTimer = setTimeout(() => {
        setIndex(i => (i + 1) % purchaseNotifications.length);
        setVisible(true);
      }, 8000);
      return () => clearTimeout(nextTimer);
    }, 5500);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  const current = purchaseNotifications[index];
  const minutesAgo = index * 7 % 30 + 2;
  return <AnimatePresence data-id="element-408">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -60,
      scale: 0.9
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -60,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-[60] max-w-[270px]" data-id="element-409">
          {/* Gradient animated border wrapper — yellow + blue accent */}
          <div className="relative rounded-2xl p-[2.5px] bg-gradient-to-r from-primary via-yellow-300 to-primary bg-[length:200%_200%] animate-[shimmer_2.5s_linear_infinite] shadow-[0_0_25px_rgba(245,197,24,0.6),0_0_50px_rgba(59,130,246,0.15)]" data-id="element-410">
            <div className="relative bg-black rounded-2xl p-3 pr-7 flex items-center gap-2.5" data-id="element-411">
              <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-1 right-1 text-zinc-500 hover:text-white transition-colors p-1" data-id="element-412">
                <X className="w-3 h-3" data-id="element-413" />
              </button>

              <div className="bg-primary text-black rounded-full p-2 shrink-0 shadow-[0_0_15px_rgba(245,197,24,0.6)]" data-id="element-414">
                <ShoppingBag className="w-4 h-4" data-id="element-415" />
              </div>

              <div className="min-w-0 flex-1" data-id="element-416">
                <div className="flex items-center gap-1 mb-0.5" data-id="element-417">
                  <CheckCircle2 className="w-3 h-3 text-primary shrink-0" data-id="element-418" />
                  <span className="text-[9px] font-extrabold text-primary uppercase tracking-wider" data-id="element-419">
                    Compra verificada
                  </span>
                </div>
                <p className="text-xs text-white leading-snug font-medium" data-id="element-420">
                  <span className="font-extrabold" data-id="element-421">{current.name}</span> compró
                  la{' '}
                  <span className="text-primary font-extrabold" data-id="element-422">
                    {current.plan}
                  </span>
                </p>
                <p className="text-[10px] text-zinc-400 mt-1 flex items-center gap-1" data-id="element-423">
                  <MapPin className="w-2.5 h-2.5 text-blue-400" data-id="element-424" />
                  {current.city} · hace {minutesAgo} min
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}